// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL, FIN_API_URL } from '../../../const';

/************************ GET SEARCH MEMBER SAVING DETAILS START ****************** */
export const getSearchMemberSavingDetailsAPI = (listData: any) => {
	const data = {
		FetchMemberSavingsDetailToken: listData,
	};
	const url = `${API_URL}getSearchMemberDetailsForMemberSavings`;
	return makeApiCall(url, data);
};
/************************ GET SEARCH MEMBER SAVING DETAILS END ****************** */

/************************ FETCH MEMBER SAVING DETAILS START ****************** */
export const fetchMemberSavingDetailsAPI = (listData: any) => {
	const data = {
		GetMemberSavingsDetailToken: listData,
	};
	const url = `${API_URL}getMemberSavingsDetails`;
	return makeApiCall(url, data);
};
/************************ FETCH MEMBER SAVING DETAILS END ****************** */

/************************ GET PARTICULAR ACCOUNT INFO START ****************** */
export const getParticularAccountInfoAPI = (listData: any) => {
	const data = {
		GetParticularAccountNameInfoToken: listData,
	};
	const url = `${FIN_API_URL}fetchParticularAccountNameInfo`;
	return makeApiCall(url, data);
};
/************************ GET PARTICULAR ACCOUNT INFO END ****************** */

/************************ ADD SAVING MEMBER SAVING ACCOUNT START ****************** */
export const addSavingMemberSavingDetailsAPI = (listData: any) => {
	const data = {
		CreateMemberSavingToken: listData,
	};
	const url = `${API_URL}createMemberSaving`;
	return makeApiCall(url, data);
};
/************************ ADD SAVING MEMBER SAVING ACCOUNT END ****************** */

/************************ DELETE SAVING MEMBER SAVING ACCOUNT START ****************** */
export const deleteSavingMemberSavingDetailsAPI = (listData: any) => {
	const data = {
		DeleteMemberSavingEntryToken: listData,
	};
	const url = `${API_URL}deleteSavingsCollection`;
	return makeApiCall(url, data);
};
/************************ DELETE SAVING MEMBER SAVING ACCOUNT END ****************** */
